import { IAssignedModule, IAssignedTask } from "../../types/generalTypes";
import TaskItem from "./TaskItem";
import { ScoreMap } from "./CurrentWeek";

export default function CurrentTasks({
  currentModule,
  scoreMap,
  resumeId,
}: {
  currentModule: IAssignedModule;
  scoreMap?: ScoreMap;
  resumeId?: number | null;
}) {
  return (
    <div className="space-y-1.5">
      {currentModule.contents.map((task: IAssignedTask) => (
        <TaskItem
          key={task.tag + task.id}
          item={task}
          showFullDate={false}
          scoreMap={scoreMap}
          isResume={task.tag === "UNIT" && task.id === resumeId}
        />
      ))}
    </div>
  );
}
